import { BookingState } from 'fitbeat.models';
import { WorkoutType } from '../../config/workouttype';
import { WorkoutSettings } from '../user';
import { UserWorkoutSession } from './userworkoutsession';

export interface IWorkoutSessionRequest extends Partial<UserWorkoutSession> {
    userProfileId: string;
    gymName: string;
    workoutType?: WorkoutType;
    settings?: WorkoutSettings;
    startTime?: Date;
    endTime?: Date;
    pairedSessionReference?: string;
    bookingState?: BookingState;
    isInstant?: boolean;
}

export class WorkoutSessionRequest implements IWorkoutSessionRequest {
    public static isConfirmedBooking(workoutSessionRequest: IWorkoutSessionRequest): boolean {
        return workoutSessionRequest && !!workoutSessionRequest.endTime;
    }

    public static hasPairedWorkoutSession(workoutSessionRequest: IWorkoutSessionRequest): boolean {
        return workoutSessionRequest.pairedSessionReference !== undefined;
    }

    public userProfileId: string;
    public gymName: string;
    public workoutType: WorkoutType;
    public settings: WorkoutSettings;
    public startTime: Date;
    public endTime: Date;
    public bookingState: BookingState;
    public isInstant: boolean;
    public openInviteLink: string;
    public isDemo: boolean;

    constructor(
        userProfileId: string,
        gymName: string,
        settings?: WorkoutSettings) {
        this.userProfileId = userProfileId;
        this.gymName = gymName;

        if (settings) {
            this.settings = settings;
        }
    }
}
